import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import List from "@material-ui/core/List";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";

import CampaignListItem from "./CampaignListItem";
import { CAMPAIGN_STATE_GROUP, THEME } from "../_constants";
import { AddCampaignPage } from "../AddCampaignPage";

const styles = theme => ({
    header: {
        display: "flex",
        flexDirection: "row",
        marginTop: 25,
        marginBottom: 25,
        alignItems: "baseline"
    },
    headerBox: {
        flexGrow: 1,
        display: "flex",
        flexDirection: "row",
        alignItems: "baseline"
    },
    colorBox: {
        width: 20,
        height: 20,
        marginRight: 20
    },
    headerTitle: {
        fontSize: theme.typography.pxToRem(20)
    },
    addButton: {
        width: "100%",
        height: 100,
        border: "1px dashed gray",
        marginBottom: 40
    },
    leftIcon: {
        marginRight: theme.spacing.unit
    },
    list: {
        paddingTop: 0
    },
    drawer: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        zIndex: 2,
        alignItems: "center",
        justifyContent: "center"
    },
    closeButton: {
        color: "white",
        position: "relative",
        top: 25,
        left: 25
    }
});

class CampaignList extends React.Component {
    state = { creatingCampaign: false, editingCampaign: null };

    render() {
        const { t, classes, group, campaigns, districtsObj } = this.props;
        // let groupColor = CAMPAIGN_STATE_GROUP[group].color;

        const self = this;

        function onUpdateCampaignList(isCreating) {
            if (isCreating) {
                self.setState({ creatingCampaign: false });
            } else {
                self.setState({ editingCampaign: null });
            }
        }

        function toggleNewCampaignForm(e, show) {
            e.preventDefault();

            self.setState({ creatingCampaign: show });
        }

        function renderAddCampaignForm() {
            return self.state.creatingCampaign === true ? (
                <div className={classes.drawer}>
                    <IconButton
                        color="primary"
                        className={classes.closeButton}
                        aria-label="Close"
                        onClick={event => toggleNewCampaignForm(event, false)}
                    >
                        <CloseIcon style={{ width: 50, height: 50 }} />
                    </IconButton>

                    <AddCampaignPage
                        emptyTimeSlot="true"
                        onUpdate={event => onUpdateCampaignList(true)}
                    />
                </div>
            ) : null;
        }

        function toggleEditCampaignForm(e, campaign) {
            e && e.preventDefault();

            self.setState({ editingCampaign: campaign });
        }

        function renderEditCampaignForm() {
            return self.state.editingCampaign ? (
                <div className={classes.drawer}>
                    <IconButton
                        color="primary"
                        className={classes.closeButton}
                        aria-label="Close"
                        onClick={event => toggleEditCampaignForm(event, null)}
                    >
                        <CloseIcon style={{ width: 50, height: 50 }} />
                    </IconButton>

                    <AddCampaignPage
                        emptyTimeSlot="false"
                        campaign={self.state.editingCampaign}
                        onUpdate={event => onUpdateCampaignList(false)}
                        onDismiss={event => toggleEditCampaignForm(event, null)}
                    />
                </div>
            ) : null;
        }

        function renderHeader(group) {
            function renderSubHeader(color = null, name = null) {
                return (
                    <div className={classes.headerBox}>
                        <div
                            className={classes.colorBox}
                            style={{
                                backgroundColor: color
                                    ? color
                                    : CAMPAIGN_STATE_GROUP[group].color
                            }}
                        />
                        <Typography
                            variant="headline"
                            className={classes.headerTitle}
                        >
                            {t(name ? name : CAMPAIGN_STATE_GROUP[group].name)}
                        </Typography>
                    </div>
                );
            }
            return (
                <div className={classes.header}>
                    {renderSubHeader()}
                    {CAMPAIGN_STATE_GROUP[group].id ===
                    CAMPAIGN_STATE_GROUP.STARTED.id
                        ? renderSubHeader(THEME.COLOR.YELLOW, "Pause")
                        : null}
                </div>
            );
        }

        function renderAddCampaignButton(group) {
            let button =
                CAMPAIGN_STATE_GROUP[group].id ===
                CAMPAIGN_STATE_GROUP.NOT_STARTED.id ? (
                    <Button
                        variant="flat"
                        className={classes.addButton}
                        onClick={event => toggleNewCampaignForm(event, true)}
                    >
                        <AddIcon className={classes.leftIcon} />
                        {t("AddCampaign")}
                    </Button>
                ) : null;

            return button;
        }

        return (
            <div
                style={{
                    width: 400
                }}
            >
                {renderHeader(group)}
                {renderAddCampaignButton(group)}
                <List className={classes.list}>
                    {campaigns.map((campaign, index) => (
                        <CampaignListItem
                            key={index}
                            // color={groupColor}
                            idx={index}
                            campaignList={this.props.campaigns}
                            districtsObj={districtsObj}
                            onEdit={(e, campaign) =>
                                toggleEditCampaignForm(e, campaign)
                            }
                        />
                    ))}
                </List>
                {renderAddCampaignForm()}
                {renderEditCampaignForm()}
            </div>
        );
    }
}

CampaignList.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(translate("translations")(CampaignList));



// WEBPACK FOOTER //
// ./src/HomePage/CampaignList.js